import React from 'react';
interface SectionHeaderProps {
  number: string;
  title: string;
  id: string;
}
export function SectionHeader({
  number,
  title,
  id
}: SectionHeaderProps) {
  return <div id={id} className="flex items-center space-x-6 mb-10 pt-20 -mt-20" data-id="element-194">
      <div className="flex-shrink-0 w-16 h-16 bg-legal-red text-white flex items-center justify-center rounded-lg shadow-md" data-id="element-195">
        <span className="text-2xl font-bold font-serif" data-id="element-196">{number}</span>
      </div>
      <h2 className="text-3xl md:text-4xl font-bold text-legal-dark uppercase tracking-tight" data-id="element-197">
        {title}
      </h2>
    </div>;
}